"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");

var _urls = require("../../../utils/urls");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- CONTROL : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'IconControl',
  props: {
    text: {
      type: 'string',
      default: 'Test'
    },
    image: {
      type: 'string',
      default: "".concat(_urls.url.static.files.images, "/iui/logo-insticator-icon.svg")
    },
    value: {
      type: 'string',
      default: 'test'
    },
    selected: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    handleSelect: {
      type: 'function',
      default: function _default(value) {
        return console.log('control selected', value);
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default2;